<template>
	<div
		@dblclick.capture="$emit('open', transporterOrder)"
		@click.capture="$emit('select', transporterOrder)"
	>
		<t-card
			background="white"
			elevation="1"
			border="default"
			class="transporter-order-card"
			:class="{selected: selected}"
		>
			<div slot="header" class="transporter-order-card-header">
				<div style="display: flex; align-items: center;">
					<t-panel-header
						:color="ordersIconColor"
						:text="ordersCount"
						icon="orders"
						size="md"
					/>
				</div>
				<t-metric-details
					:value="transporterOrder.volume"
					hide-max
					hide-pie-icon
					class="card-details"
					decimals="1"
					vertical
					unit="m3"
					size="small"
				/>
				<t-metric-details
					:value="transporterOrder.grossWeight"
					hide-max
					hide-pie-icon
					class="card-details"
					vertical
					unit="kg"
					size="small"
				/>
				<t-metric-details
					:value="transporterOrder.loadingMeters"
					hide-max
					hide-pie-icon
					class="card-details"
					decimals="1"
					vertical
					unit="lm"
					size="small"
				/>
			</div>
			<div class="vendor-info">
				<div class="vendor-name">
					{{transporterOrder.vendor.name}}
				</div>
				<div class="vendor-vendor-number">
					{{transporterOrder.vendor.vendorNumber}}
				</div>
			</div>
		</t-card>
	</div>
</template>

<script>
export default {
	name: 'TTransporterOrderCard',
	props: {
		/** transporterOrder */
		transporterOrder: Object,
		/** Color of orders icon */
		ordersIconColor: String,
		/** Selected */
		selected: Boolean,
	},
	computed: {
		ordersCount() {
			return this.transporterOrder.orders ? this.transporterOrder.orders.length : 0;
		}
	}
};
</script>
<style lang="scss" scoped>
@import '~@/components/evergreen/scss/text';
@import '~@/components/evergreen/scss/colors';
.selected  {
	box-shadow: 0 0 2px get-color($neutral-scale, 'N4A'),
				0 0 0 1px get-color($blue-scale, 'B8'),
				0 0 0 3px get-color($blue-scale, 'B5A') !important;
	cursor: pointer;
	.transporter-order-card-header {
		background-color: get-color($blue, 'light');
		border-color: get-color($blue, 'light');
	}
}
.transporter-order-card {
	width: 240px;
	height: 124px;
	&:hover {
		box-shadow: 0 0 2px get-color($neutral-scale, 'N4A'),
				0 0 0 1px get-color($blue-scale, 'B7'),
				0 0 0 3px get-color($blue-scale, 'B4A');
		cursor: pointer;
		.transporter-order-card-header {
			background-color: get-color($blue, 'light');
			border-color: get-color($blue, 'light');
		}
	}

	.transporter-order-card-header {
		height: 45px;
		padding: 0px 8px 0px 5px;
		background-color: #edf0f2;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #E4E7EB;
	}

	.vendor-info {
		flex: 1;
		grid-row: 2/4;
		grid-column: 2;
		margin-left: 30px;
		padding-top:5px;
		.vendor-name {
			font-size: 12px;
			font-weight: 600;
			font-style: normal;
			font-stretch: normal;
			line-height: 1;
			letter-spacing: 0px;
			color: get-color($text, 'dark');
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}

		.vendor-vendor-number {
			font-size: 10px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 1.6;
			letter-spacing: normal;
			color: get-color($text, 'dark');
		}
	}
}
</style>


<docs>
```jsx
<div>
	<t-transporter-order-card
		ordersCount="7"
		ordersIconColor="blue"
		vehicleIcon="trailer"
		vehicleIconColor="blue"
	/>
</div>
```
</docs>